import { createNotification } from "../../../app/state/notificationSlice/slice";
import { AppDispatch } from "../../../services/redux/types";
import { uploadFileAction } from "../../Files/redux/actions";
import { TDataFile } from "../../Files/types";

export const isXmlBroken = (str: string): boolean => {
  return (
    /[\xD0-\xD1][\x80-\xBF]/.test(str) || str.includes("Ã") || str.includes("Ð")
  );
};

export const fixEncoding = (broken: string): string => {
  try {
    const bytes = Uint8Array.from(broken, (c) => c.charCodeAt(0));
    const fixed = new TextDecoder("utf-8").decode(bytes);

    return fixed.includes("?") ? broken : fixed;
  } catch {
    return broken;
  }
};

export const downloadFile = (file: File) => {
  const url = URL.createObjectURL(file);
  const a = document.createElement("a");
  a.href = url;
  a.download = file.name;
  a.click();
  URL.revokeObjectURL(url);
};

export const uploadFile = (file: File, dispatch: AppDispatch) => {
  const uploadFile: TDataFile[] = [{ id: "1", file_name: file.name, file }];
  dispatch(uploadFileAction({ data: uploadFile }))
    .unwrap()
    .then(() =>
      dispatch(
        createNotification("success", "Файл добавлен в Артефакты", 3000),
      ),
    );
};
